import { render, staticRenderFns } from "./work-view.vue?vue&type=template&id=6c166e07&scoped=true&"
import script from "./work-view.vue?vue&type=script&lang=js&"
export * from "./work-view.vue?vue&type=script&lang=js&"
import style0 from "./work-view.vue?vue&type=style&index=0&id=6c166e07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c166e07",
  null
  
)

export default component.exports